export enum ActionTypesGlobalNotifs {
  SET_OK = "SET_OK",
  SET_INFO = "SET_INFO",
  SET_ERROR = "SET_ERROR",
  SET_LOADING = "SET_LOADING",
  CLEAR = "CLEAR",
}

export interface ActionGlobalNotifsBase {
  type: ActionTypesGlobalNotifs;
  payload?: any;
}

interface IPayload {
  readonly text: string;
  readonly timer?: number;
}

export interface ActionSetOK extends ActionGlobalNotifsBase {
  readonly payload: string;
}

export interface ActionSetInfo extends ActionGlobalNotifsBase {
  readonly payload: string;
}

export interface ActionSetError extends ActionGlobalNotifsBase {
  readonly payload: IPayload;
}
export interface ActionSetLoading extends ActionGlobalNotifsBase {
  readonly payload: boolean;
}

export interface ActionClear extends ActionGlobalNotifsBase {}
